module.exports = __webpack_public_path__ + "media/images/sports_coaching/stella@2x-fa14e891e8fee7da9dd733533107a7e6.jpg";